import {ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FormRichFieldConfig} from '../../../../model/api/form-rich-field-config';
import {FormFieldConfig} from '../../../../model/api/form-field-config';
import {CcSubFormBaseComponent} from "../cc-sub-form-base.component";
import {CcFormComponent} from "../cc-form.component";
import {CcFormDialogComponent} from "../../cc-form-dialog.component";

@Component({
  selector: 'cc-single-rich-field[fieldName][formRichFieldConfig][formRecord]',
  templateUrl: './single-rich-field.component.html',
  styleUrls: ['./single-rich-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    TranslateService,
  ]
})
export class SingleRichFieldComponent extends CcSubFormBaseComponent {


  @Input()
  formRichFieldConfig: FormRichFieldConfig;

  contextMenuConfig: MenuItem[];

  @Input()
  fieldName: String;

  @Input()
  formRecord: any;
  @Output()
  formRecordChange = new EventEmitter<any>();

  @Input()
  required: boolean;

  @Input()
  disabled: boolean;

  @Input()
  transPartKey: string;

  fieldValueMap = {};

  dialogFormVisible: boolean;
  dialogFormTitle: string = '';

  submitted: boolean;

  formRecordInForm: any;
  editedFormRecordCopy: any;

  tableLoading: boolean;

  @ViewChild('ccFormDialog')
  ccFormDialog: CcFormDialogComponent;

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService,
              private confirmationService: ConfirmationService) {
    super(cdref, messageService, translateService);
  }

  edit(record: any) {
    this.dialogFormTitle = this.getTranslation('common.table.edit_item') + ' '
      + this.fieldName;
    this.editedFormRecordCopy = record;
    this.formRecordInForm = JSON.parse(JSON.stringify(record));
    this.dialogFormVisible = true;
    this.markForCheck();
  }

  hideDialog() {
    this.dialogFormVisible = false;
    this.submitted = false;
    this.markForCheck();
  }

  save() {
    this.submitted = true;

    this.formRecord = this.formRecordInForm;
    this.formRecordInForm = undefined;
    this.dialogFormVisible = false;
    this.reloadFieldValueMap();
    this.formRecordChange.emit(this.formRecord);
    this.markForCheck();
  }

  onRowRightClick_(record: any) {
  }

  private validateForm(): string {
    if (!this.formRecordInForm) {
      return undefined;
    }
    let message;
    this.formRichFieldConfig.fields.forEach(configGrp => {
      configGrp.fields.forEach(config => {
        if (!message) {
          const fieldMessage = this.validateField(config);
          if (fieldMessage) {
            message = fieldMessage;
          }
        }
      });
    });
    return message;
  }

  private validateField(fieldConfig: FormFieldConfig): string {
    if (!this.formRecordInForm) {
      return '';
    }
    let message;
    if (fieldConfig.required
      && (!this.formRecordInForm[fieldConfig.field] || (this.formRecordInForm[fieldConfig.field] + '').length === 0)) {
      message = this.getTranslation('page.' + this.transPartKey + '.form.' + fieldConfig.field) + ' '
        + this.getTranslation('common.form.required_sing');
    } else if (fieldConfig.validate) {
      message = fieldConfig.validate(this.formRecordInForm);
    }
    return message;
  }

  clear() {
    this.tableLoading = true;
    this.confirmationService.confirm({
      header: this.getTranslation('common.table.clear_item')
        + ' ' + this.getTranslation('page.' + this.transPartKey + '.item_name'),
      message: (this.getTranslation('common.dialog.confirm_clear') + ' ' + this.fieldName + '?'),
      icon: 'fas fa-exclamation-triangle',
      acceptLabel: this.getTranslation('common.dialog.clear'),
      acceptButtonStyleClass: 'p-button-danger p-button-sm',
      rejectLabel: this.getTranslation('common.dialog.cancel'),
      rejectButtonStyleClass: 'p-button-warning p-button-sm',
      accept: () => {
        this.formRecord = {};
        this.formRecordInForm = {};
        this.formRecordChange.emit(this.formRecord);
        this.tableLoading = false;
      },
      reject: () => {
        this.tableLoading = false;
      }
    });

  }

  reloadFieldValueMap() {
    if (this.formRichFieldConfig && this.formRichFieldConfig.tableConfigs && this.formRecord)
      this.formRichFieldConfig.tableConfigs.forEach((conf, index) => {
        if (conf.format && conf.format.includes('#'))
          conf.format = '1.0-7';
        if (conf.mapId)
          this.fieldValueMap['mapId-' + index] = conf.mapId(this.formRecord);
      });
    this.fieldValueMap['validate'] = this.validateForm();
    super.reloadFieldValueMap();
    if (this.ccFormDialog)
      this.ccFormDialog.reloadFieldValueMap();
  }
}
